// extracted by mini-css-extract-plugin
export default {"min_container":"Migrate_min_container__9Cs1m","text_container":"Migrate_text_container__VXSqf","btn_container":"Migrate_btn_container__mrMlF"};